import {
    addToChainAfter,
    addToChainBefore,
    Handler,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    CartResult,
    updateCart as updateCartApi,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    DispatchBeginUpdateBillTo,
    LoadCart,
    LoadSession,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateBillTo";
import { chain } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateBillTo";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        billTo: BillToModel;
        isEdit: boolean;
    } & HasOnSuccess<boolean>,
    {
        shipTos: ShipToModel[];
        defaultShipTo: ShipToModel;
    }
>;

export const LoadCartExtended: HandlerType = async props => {
    const state = props.getState();
    const { cartId } = state.pages.onePageCheckout;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (cartId && cart?.typeDisplay === "Quote") {
        props.dispatch(loadCart({ cartId, getPromotions: true }));
    } else {
        await makeHandlerChainAwaitable(loadCurrentCart)({ getCartLines: true })(props.dispatch, props.getState);
    }
};

replaceInChain(chain, LoadCart, LoadCartExtended);
